import { MapPin, MessageSquareText, Wrench, LifeBuoy } from "lucide-react";
import { STEP_NAMES } from "./serviceContent";

export const TRUST_POINTS = [
  { icon: MapPin, title: "Local support in Chatham-Kent", desc: "A nearby team that knows the area and can come on site when the job needs it." },
  { icon: MessageSquareText, title: "Plain-language advice", desc: "Clear explanations and honest recommendations, so you know exactly what you're getting and why." },
  { icon: Wrench, title: "Professional installation", desc: "Careful, tidy work with cabling and equipment set up properly the first time." },
  { icon: LifeBuoy, title: "Support after installation", desc: "We stay available for questions, changes and fixes once the work is finished." },
];

export const Trust = () => (
  <section id="trust" data-testid="trust-section" className="bg-white py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <div className="max-w-2xl">
        <p className="eyebrow">Why JMS</p>
        <h2 className="h2 mt-4">What You Can Expect From Us</h2>
        <p className="lead mt-4">No jargon and no surprises: just clear advice, good work and a team that's still here after installation.</p>
      </div>
      <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {TRUST_POINTS.map(({ icon: Icon, title, desc }, i) => (
          <li key={title} data-testid={`trust-point-${i}`} className="soft-card p-7">
            <span className="grid h-12 w-12 place-items-center rounded-xl bg-brand-offwhite"><Icon className="h-6 w-6 text-brand-blue" strokeWidth={1.6} /></span>
            <h3 className="mt-5 font-heading text-base font-semibold text-brand-navy">{title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-brand-slate">{desc}</p>
          </li>
        ))}
      </ul>
      <div className="mt-16 rounded-2xl border border-brand-surface bg-brand-offwhite p-7 sm:p-10" data-testid="trust-process">
        <h3 className="font-heading text-lg font-semibold text-brand-navy">How we work</h3>
        <ol className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STEP_NAMES.map((name, i) => (
            <li key={name} className="flex items-start gap-3">
              <span className="font-heading text-sm font-semibold text-brand-blue">0{i + 1}</span>
              <span className="text-sm font-medium text-brand-navy">{name}</span>
            </li>
          ))}
        </ol>
      </div>
    </div>
  </section>
);
